import { Helmet } from "react-helmet";

export default function ErrorPage(){
    return(
        <div className='bg-gray-200 text-gray-600 h-screen w-full flex justify-center items-center'>
            <Helmet>
                <title>Page not found</title>
            </Helmet>
            <div className='text-center'>
                <h1 className='font-bold text-8xl'>404</h1>
                <p className='text-4xl'>Page not found!</p>
            </div>
        </div>
    );
}